module.exports = __webpack_public_path__ + "img/og-whatsapp.74307108.webp";